import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import ShoppingCartProgressBar from '../../../components/ecommerce/shopping-cart-progress/shopping-cart-progress.component';

function PaymentHeaderComponent() {
  return (
    <Row>
      <ShoppingCartProgressBar />
    </Row>
  );
}

export default PaymentHeaderComponent;
